/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GenerationEffortOption = {
  effort: GenerationEffortOption.effort;
  label: string;
  model_name: string | null;
  beyond_firm_max: boolean;
};
export namespace GenerationEffortOption {
  export enum effort {
    FASTEST = 'fastest',
    STANDARD = 'standard',
    BALANCED = 'balanced',
    HIGH = 'high',
    MAXIMUM = 'maximum',
  }
}

